import React from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import { Check, FormTypes } from "MODULES/shared/components/Forms";
import { Fields, FormSection } from "redux-form";
import {
  COMPANY,
  DROPSHIP,
  RESERVE_FOR_SALE_QUANTITY,
  PURCHASE_FOR_STOCK,
  PURCHASE_FOR_REPAIR_ASSIST,
  PURCHASE_FOR_SALE,
  PURCHASE_FOR_REPAIR
} from "MODULES/PurchaseOrders/constants";
import { Col } from "react-bootstrap";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { AS_IS } from "MODULES/IncomingQuotes/constants";
import { ReserveForSaleFields } from "MODULES/PurchaseOrders/shared/PurchaseForFields";

function PurchaseForCheckboxes({
  purchase_for_stock: { input: stock },
  purchase_for_repair_assist: { input: assist },
  purchase_for_sale: { input: sale },
  purchase_for_repair: { input: repair },
  clearPurchaseFor,
  clearReserveForSaleQty,
  disabled,
  shippingType,
  onPurchaseForStockChange,
  onPurchaseForSaleChange
}) {
  return (
    <div className="form-group" style={{ cursor: "pointer" }}>
      <label className="control-label" htmlFor="purchase_for">
        Purchase For <sup className="small text-danger">*</sup>
      </label>
      <div
        id="purchase_for"
        className="btn-group btn-group-justified"
        data-toggle="buttons"
      >
        <Check
          input={stock}
          label="Stock"
          icon="fa-check-circle"
          disabled={disabled || [COMPANY, DROPSHIP].includes(shippingType)}
          onChange={ev => {
            onPurchaseForStockChange(ev);
            clearPurchaseFor(ev, [sale.name, repair.name, assist.name]);
            clearReserveForSaleQty(ev);
          }}
        />
        <Check
          disabled={disabled}
          input={assist}
          label="Repair Assist"
          icon="fa-check-circle"
          onChange={ev => {
            clearPurchaseFor(ev, [sale.name, repair.name, stock.name]);
            clearReserveForSaleQty(ev);
          }}
        />
        <Check
          disabled={disabled}
          input={sale}
          label="Reserve for Sale"
          icon="fa-check-circle"
          onChange={ev => {
            clearPurchaseFor(ev, [stock.name, repair.name, assist.name]);
            clearReserveForSaleQty(!ev);
            onPurchaseForSaleChange(ev);
          }}
        />
        <Check
          input={repair}
          disabled={disabled}
          label="Reserve for Repair"
          icon="fa-check-circle"
          onChange={ev => {
            clearPurchaseFor(ev, [stock.name, sale.name, assist.name]);
            clearReserveForSaleQty(ev);
          }}
        />
      </div>
    </div>
  );
}

PurchaseForCheckboxes.propTypes = {
  clearPurchaseFor: PropTypes.func.isRequired,
  clearReserveForSaleQty: PropTypes.func.isRequired,
  purchase_for_stock: PropTypes.shape({
    input: FormTypes.boolInput.isRequired
  }),
  purchase_for_repair_assist: PropTypes.shape({
    input: FormTypes.boolInput.isRequired
  }),
  purchase_for_sale: PropTypes.shape({ input: FormTypes.boolInput.isRequired }),
  purchase_for_repair: PropTypes.shape({
    input: FormTypes.boolInput.isRequired
  }),
  shippingType: PropTypes.string,
  disabled: PropTypes.bool,
  onPurchaseForSaleChange: PropTypes.func,
  onPurchaseForStockChange: PropTypes.func
};

PurchaseForCheckboxes.defaultProps = {
  onPurchaseForStockChange: () => null
};

export default function PurchaseForFields({
  clearPurchaseFor = () => {},
  prefix = "",
  searchBuyers,
  selectedReserveForSeller,
  shippingType,
  disabled,
  getFieldValue = () => {},
  qtyDisabled,
  condition,
  onPurchaseForStockChange,
  onPurchaseForSaleChange,
  setFieldValue
}) {
  const clearReserveForSaleQty = ev => {
    if (ev) {
      const field = [prefix, RESERVE_FOR_SALE_QUANTITY]
        .filter(f => !isEmpty(f))
        .join(".");
      setFieldValue(field)(0);
    }
  };

  return (
    <FormSection name={prefix}>
      <FormRow>
        <Col md={12}>
          <Fields
            names={[
              PURCHASE_FOR_STOCK,
              PURCHASE_FOR_REPAIR_ASSIST,
              PURCHASE_FOR_SALE,
              PURCHASE_FOR_REPAIR
            ]}
            asIs={getFieldValue(
              [prefix, AS_IS].filter(f => !isEmpty(f)).join(".")
            )}
            clearPurchaseFor={clearPurchaseFor}
            component={PurchaseForCheckboxes}
            shippingType={shippingType}
            disabled={disabled}
            condition={condition}
            onPurchaseForStockChange={onPurchaseForStockChange}
            onPurchaseForSaleChange={onPurchaseForSaleChange}
            required
            clearReserveForSaleQty={clearReserveForSaleQty}
          />
        </Col>
      </FormRow>
      <Fields
        names={[PURCHASE_FOR_SALE]}
        prefix={prefix}
        component={ReserveForSaleFields}
        disabled={disabled}
        getFieldValue={getFieldValue}
        qtyDisabled={qtyDisabled}
        searchBuyers={searchBuyers}
        selectedReserveForSeller={selectedReserveForSeller}
      />
    </FormSection>
  );
}

PurchaseForFields.propTypes = {
  clearPurchaseFor: PropTypes.func,
  condition: PropTypes.string,
  getFieldValue: PropTypes.func,
  prefix: PropTypes.string,
  shippingType: PropTypes.string,
  disabled: PropTypes.bool,
  qtyDisabled: PropTypes.bool,
  searchBuyers: PropTypes.func.isRequired,
  selectedReserveForSeller: PropTypes.shape({}),
  setFieldValue: PropTypes.func.isRequired,
  onPurchaseForSaleChange: PropTypes.func,
  onPurchaseForStockChange: PropTypes.func
};

PurchaseForCheckboxes.defaultProps = {
  onPurchaseForStockChange: () => null,
  onPurchaseForSaleChange: () => null
};



// WEBPACK FOOTER //
// ./app/modules/Lots/Detail/LineItemsTable/PurchaseForFields.jsx